<template>
  <div>
    <div class="page-header clear-filter" filter-color="black">
      <parallax
        class="page-header-image"
        style="background-image:url('/img/galleries/large/wildlife/PB182847rm.jpg'); background-position: 0% 55%"
      ></parallax>
    </div>
    <div class="section">
      <div class="container">
        <div class="photo-container">
          <img src="img/me.jpg" alt=""/>
        </div>
      </div>

      <div class="container title-container">
        <h3 class="title">Mathias Möller</h3>
        <p class="about-text">
          Hi there! I am Mathias. I am a hobby photographer and I love to shoot landscapes, cultures and their people.
          Therefore, I am always looking forward to my next journey to capture new and fascinating moments.
          You like my pictures?
          Feel free to contact me regarding image acquisition or assignments or if you just want to say hi!
        </p>
      </div>

      <div class="container">
        <h3 class="title">Get in Touch</h3>
        <div class="icon-row">
          <a
            class="nav-link"
            rel="tooltip"
            title="Follow me on Instagram"
            data-placement="bottom"
            href="https://www.instagram.com/mathiasmoelle_r"
            target="_blank"
          >
            <i class="fab fa-instagram"></i>
          </a>
          <a
            class="nav-link"
            rel="tooltip"
            title="Follow me on Facebook"
            data-placement="bottom"
            href="https://www.facebook.com/matze.moller.9"
            target="_blank"
          >
            <i class="fab fa-facebook-square"></i>
          </a>
          <a
            class="nav-link"
            rel="tooltip"
            title="Send me a mail"
            data-placement="bottom"
            href="mailto:mail@mathiasmoeller.com"
            target="_blank"
          >
            <i class="fas fa-envelope"></i>
          </a>
        </div>
      </div>

      <div class="container stock-container">
        <h3 class="title">Find me on Stock</h3>
        <stock/>
      </div>
    </div>
  </div>
</template>
<script>
  import { Stock } from '@/components';
  import { metaTitles, metaDescriptions, metaImage } from '@/utils/meta';

  export default {
    name: 'about',
    bodyClass: 'profile-page',
    metaInfo: {
      title: 'About',
      meta: [
        ...metaTitles('About'),
        ...metaDescriptions('Let\'s get in touch'),
        ...metaImage('/img/galleries/thumbs/wildlife/PB182847rm-small.jpg', 640, 400),
      ],
    },
    components: {
      Stock,
    },
  };
</script>
<style lang="scss" scoped>
  .section {
    .photo-container {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: -100px;
      width: 200px;
      height: 200px;

      @media (max-width: 576px) {
        top: -75px;
        width: 150px;
        height: 150px;
      }
    }
  }

  .title-container {
    margin-top: 70px;
  }

  .stock-container {
    margin-bottom: 50px;
  }

</style>
